import {
  EllipsisOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Spin,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useNavigate, useParams } from "react-router";
import SelectProduct from "../../../components/SelectProduct";
import SelectPallet from "../../../components/SelectPallet";
import SelectOperator from "../../../components/SelectOperator";
import API from "../../../services/api-request";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { capitalizeLetter } from "../../../utils/capitalizeLetter";
import SelectLayout from "../../../components/SelectLayout";
import ItemPrint from "../../../components/print/print_item";
import Process from "./process";
import SelectLayoutNew from "../../../components/select-layout/SelectLayoutNew";
import SelectMaterialHandling from "../../../components/SelectMaterialHandling";
import { baseUrl } from "../../../config/url-config";

const StartInbound = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editForm] = Form.useForm();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selectionIndex, setSelectionIndex] = useState(0);
  const [selectedArea, setSelectedArea] = useState({});

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [openProcess, setOpenProcess] = useState(false);
  const [palletType, setPalletType] = useState(null);

  const [isCustomMaterialHandling, setIsCustomMaterialHandling] =
    useState(false);
  const [materialHandlingChecked, setMaterialHandlingChecked] = useState(false);

  const [draftData, setDraftData] = useState([]);
  const [confirmDraft, setConfirmDraft] = useState(false);
  const [confirmDraftLoading, setConfirmDraftLoading] = useState(false);
  const [selectedPallet, setSelectedPallet] = useState(null);

  const [confirmInbound, setConfirmInbound] = useState(false);

  const onSelectedMaterialHandling = (value, options) => {
    editForm.setFieldValue("material_handling_fee_type", value);
    editForm.setFieldValue("material_handling_fee_cost", options?.cost);
    setIsCustomMaterialHandling(value === "custom");
  };

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const getDataDetail = (id) => {
    setLoading(true);
    API.Get(`transaction/inbound/detail/${id}`)
      .then((result) => {
        setLoading(false);

        setDraftData({
          transaction_id:
            result?.data?.transaction_details?.[0]?.transaction_id,
        });

        const transformedItem = {
          ...result?.data,
          status: capitalizeLetter(result?.data?.status),
          client: result?.data?.client?.name,
          client_id: result?.data?.client?.id,
          request_at: dayjs(result?.data?.request_at).format("YYYY-MM-DD"),
          schedule_at: dayjs(result?.data?.schedule_at).format("YYYY-MM-DD"),
          details: result?.data?.transaction_details?.map((e) => {
            return {
              transaction_detail_id: e.id,
              product_id: e.product_id,
              qty: e.estimate_qty,
              weight: e.estimate_weight,
              specification: e.estimate_specification,
              area_id: null,
              pallet_id: null,
            };
          }),
        };

        editForm.setFieldsValue(transformedItem);

        setData(transformedItem);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        message.info("Failed Fetch Inbound Detail");
      });
  };

  useEffect(() => {
    console.log(id);
    if (id) {
      getDataDetail(id);
    }
  }, [id]);

  const onFinish = async (values) => {
    setLoadingBtn(true);
    try {
      const {
        code,
        client_id,
        note,
        material_handling_fee_type,
        material_handling_fee_cost,
        request_at,
        schedule_at,
        details,
      } = values;

      let dataForm = {
        transaction_id: draftData.transaction_id || null,
        code,
        client_id,
        note,
        request_at: dayjs(request_at).format("YYYY-MM-DD"),
        schedule_at: dayjs(schedule_at).format("YYYY-MM-DD"),
        material_handling_fee_cost: material_handling_fee_cost ?? 0,
        details: details.map((e) => {
          return {
            transaction_detail_id: e.transaction_detail_id,
            product_id: e.product_id,
            qty: e.qty ?? 0,
            weight: parseFloat(
              e.weight -
                (palletType === "kayu"
                  ? +e.pallet_weight + 10
                  : e.pallet_weight),
            ),
            specification: e.specification ?? "",
            area_id: e.area_id,
            pallet_id: e.pallet_id,
            operator_id: e.operator_id,
            pallet_weight:
              palletType === "kayu" ? +e.pallet_weight + 10 : +e.pallet_weight,
          };
        }),
      };

      const validAreaPalletMapping = isValidAreaPalletMapping(dataForm.details);

      if (!validAreaPalletMapping) {
        message.warning(
          `Terdapat area duplikat dengan pallet berbeda, silahkan cek kembali.`,
        );
        return;
      }

      if (editForm.getFieldValue("material_handling_fee_type")) {
        dataForm.material_handling_fee_type = material_handling_fee_type;
      }

      await API.Post("transaction/inbound/opt-in", dataForm);
      message.success("Inbound has been added");
      editForm.resetFields();
      handleBack();
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setLoadingBtn(false);
      setConfirmInbound(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setConfirmInbound(false);
    console.log("Failed:", errorInfo);

    if (errorInfo?.errorFields?.length > 0) {
      setDraftData((prev) => ({ ...prev, ...errorInfo?.values }));
      setConfirmDraft(true);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const items = (index, remove) => [
    // {
    //   label: "Proses",
    //   onClick: () => {
    //     setSelectionIndex(index);
    //     showModalProcess();
    //   },
    // },
    {
      label: "Print",
      onClick: () => {
        handlePrint(index);
      },
    },
    {
      label: "Print from Android",
      onClick: () => {
        handlePrint(index, true);
      },
    },
    {
      label: "Delete",
      onClick: () => remove(index),
    },
  ];

  const saveDraft = async () => {
    setConfirmDraftLoading(true);

    try {
      const {
        code,
        client_id,
        schedule_at,
        details,
        note,
        material_handling_fee_type,
        material_handling_fee_cost,
        request_at,
        transaction_id,
      } = draftData;

      const missingPallet = details.find((e) => !e.pallet_id);
      if (missingPallet) {
        message.warning("Pallet wajib diisi.");
        setConfirmDraftLoading(false);
        return;
      }

      if (!client_id) {
        message.warning("Nama pemilik wajib diisi.");
        setConfirmDraftLoading(false);
        return;
      }

      let dataForm = {
        status: "draft",
        code,
        transaction_id,
        client_id,
        schedule_at: dayjs(schedule_at).format("YYYY-MM-DD"),
        request_at: dayjs(request_at).format("YYYY-MM-DD"),
        details: details.map((e) => {
          return {
            area_id: e.area_id,
            pallet_id: e.pallet_id,
            operator_id: e.operator_id,
            product_id: e.product_id,
            qty: e.qty,
            specification: e.specification,
            weight: e.weight,
            pallet_weight: e.pallet_weight,
          };
        }),
        note,
        material_handling_fee_cost: material_handling_fee_cost ?? 0,
      };

      const validAreaPalletMapping = isValidAreaPalletMapping(dataForm.details);

      if (!validAreaPalletMapping) {
        message.warning(
          `Terdapat area duplikat dengan pallet berbeda, silahkan cek kembali.`,
        );
        return;
      }

      if (editForm.getFieldValue("material_handling_fee_type")) {
        dataForm.material_handling_fee_type = material_handling_fee_type;
      }

      await API.Post("transaction/inbound/direct", dataForm);
      message.success("Inbound has been added as draft");
      editForm.resetFields();
      handleBack();
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setConfirmDraftLoading(false);
      setConfirmDraft(false);
    }
  };

  const handlePrint = async (index = null, thermer = false) => {
    const allProducts = editForm.getFieldValue("details") || [];
    const scheduleAt = editForm.getFieldValue("schedule_at") || null;
    const palletName = selectedPallet?.label;

    const productsToPrint = index !== null ? [allProducts[index]] : allProducts;

    const validProducts = productsToPrint
      .filter((product) => product?.area_id)
      .map((product) => ({
        ...product,
        scheduleAt: scheduleAt,
      }));

    if (validProducts.length === 0) {
      return message.info(
        index !== null
          ? "Data di baris ini belum lengkap untuk dicetak."
          : "Tidak ada data yang bisa dicetak.",
      );
    }

    if (thermer) {
      let url = "area/response";

      if (thermer) {
        const params = new URLSearchParams();

        if (validProducts?.[0]?.warehouse) {
          params.append("warehouseName", validProducts?.[0]?.warehouse);
        }
        if (validProducts?.[0]?.area) {
          params.append("areaName", validProducts?.[0]?.area);
        }
        if (scheduleAt) {
          params.append("tanggal", dayjs(scheduleAt).format("DD-MM-YYYY"));
        }
        if (palletName) {
          params.append("palletNo", palletName);
        }

        const queryString = params.toString();
        if (queryString) {
          url += `?${queryString}`;
        }
      }

      window.open(
        `my.bluetoothprint.scheme://${baseUrl + "/" + url}`,
        "_blank",
      );

      return;
    }

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(ItemPrint(validProducts));

    setTimeout(function () {
      printWindow.document.close();
    }, 2000);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print({ showPrintDialog: true });

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  const handleOk = (value) => {
    editForm.setFieldValue(["details", selectionIndex, "area_id"], value.id);
    editForm.setFieldValue(["details", selectionIndex, "area"], value.name);
    editForm.setFieldValue(["details", selectionIndex, "level"], value.level);
    editForm.setFieldValue(
      ["details", selectionIndex, "warehouse"],
      value.warehouse_name,
    );

    setOpen(false);
    setSelectedArea({});
  };

  const showModalProcess = () => {
    setOpenProcess(true);
  };

  const handleCancelProcess = () => {
    setOpenProcess(false);
  };

  const handleOkProcess = (data) => {
    if (data.pallet.id) {
      onSelectedPallet(data.pallet.id, data.pallet);
      editForm.setFieldValue(
        ["details", selectionIndex, "pallet_id"],
        data.pallet.id,
      );
    }

    if (data.operator.id) {
      editForm.setFieldValue(
        ["details", selectionIndex, "operator_id"],
        data.operator.id,
      );
    }

    editForm.setFieldValue(
      ["details", selectionIndex, "weight"],
      data.weight.weight,
    );
  };

  const onSelectedPallet = (value, options, index) => {
    if (value) {
      setSelectedPallet(options);

      editForm.setFieldValue(["details", index, "pallet_name"], options?.label);

      editForm.setFieldValue(["details", index, "pallet_weight"], "");
      if (!options?.type) return;

      setPalletType(options.type);
      if (options.type === "besi") {
        editForm.setFieldValue(["details", index, "pallet_weight"], 85);
      }
    }
  };

  function isValidAreaPalletMapping(details) {
    const areaToPallet = new Map();
    const palletToArea = new Map();

    for (const p of details) {
      const { area_id, pallet_id } = p;

      const existingPallet = areaToPallet.get(area_id);
      const existingArea = palletToArea.get(pallet_id);

      // First time seeing this area
      if (!existingPallet && !existingArea) {
        areaToPallet.set(area_id, pallet_id);
        palletToArea.set(pallet_id, area_id);
        continue;
      }

      // Check consistency: both directions must match the first combo
      if (existingPallet !== undefined && existingPallet !== pallet_id) {
        return false; // same area, different pallet
      }

      if (existingArea !== undefined && existingArea !== area_id) {
        return false; // same pallet, different area
      }
    }

    return true;
  }

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <Form
            form={editForm}
            name="Edit Form"
            style={{
              margin: "0 auto",
            }}
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row justify={"space-between"} align={"middle"}>
              <Col lg={12} md={12} sm={12} xs={24}>
                <h2>Start Inbound</h2>
              </Col>
              <Col lg={2} md={2} sm={3} xs={24}>
                <Row justify={"end"}>
                  <Button
                    type="primary"
                    icon={<PrinterOutlined />}
                    style={{
                      backgroundColor: "#4caf50",
                      color: "#fff",
                      borderColor: "#4caf50",
                      width: "100%",
                    }}
                    onClick={() => handlePrint()}
                  >
                    Print All
                  </Button>
                </Row>
              </Col>
            </Row>
            <hr />
            <br />
            <Row gutter={[8, 8]}>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item label="Kode" name="code">
                  <Input placeholder="Masukan Kode" />
                </Form.Item>
              </Col>
              <Col lg={6} md={6} sm={6} xs={24}>
                <Form.Item
                  label={
                    <span>
                      <Checkbox
                        checked={materialHandlingChecked}
                        onChange={() => {
                          setMaterialHandlingChecked(!materialHandlingChecked);
                          editForm.setFieldValue(
                            "material_handling_fee_type",
                            null,
                          );
                          editForm.setFieldValue(
                            "material_handling_fee_cost",
                            null,
                          );
                          setIsCustomMaterialHandling(false);
                        }}
                      />{" "}
                      Material Handling
                    </span>
                  }
                  name="material_handling_fee_type"
                >
                  <SelectMaterialHandling
                    onChange={onSelectedMaterialHandling}
                    disabled={!materialHandlingChecked}
                  />
                </Form.Item>
              </Col>
              <Col lg={6} md={6} sm={6} xs={24}>
                <Form.Item
                  label="Material Handling Fee per kg"
                  name="material_handling_fee_cost"
                >
                  <InputNumber
                    placeholder="Material Handling Fee"
                    prefix="Rp"
                    min={0}
                    controls={false}
                    style={{
                      width: "100%",
                    }}
                    disabled={!materialHandlingChecked}
                    readOnly={!isCustomMaterialHandling}
                  />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Pemilik"
                  name="client"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Pemilik!",
                    },
                  ]}
                >
                  <Input placeholder="Pemilik" readOnly />
                </Form.Item>
              </Col>
              <Form.Item name="client_id" hidden>
                <Input />
              </Form.Item>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Status"
                  name="status"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Status!",
                    },
                  ]}
                >
                  <Input placeholder="Status" readOnly />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Tanggal Request"
                  name="request_at"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Tanggal Request!",
                    },
                  ]}
                >
                  <Input placeholder="Tanggal Request" readOnly />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Tanggal Masuk"
                  name="schedule_at"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Tanggal Masuk!",
                    },
                  ]}
                >
                  <Input placeholder="Tanggal Masuk" readOnly />
                </Form.Item>
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                <Form.Item label="Silahkan Scan RFID">
                  <Form.List name="details">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((field, index) => (
                          <Row key={field.key} gutter={[4, 4]} align="top">
                            {/* Pallet */}
                            <Col span={2}>
                              <Form.Item
                                {...field}
                                name={[field.name, "pallet_id"]}
                                fieldKey={[field.fieldKey, "pallet_id"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input jenis pallet!",
                                  },
                                ]}
                              >
                                <SelectPallet
                                  allowUsed={false}
                                  onChange={(value, options) => {
                                    onSelectedPallet(value, options, index);
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            {/* Pallet Weight*/}
                            <Col span={2}>
                              <Form.Item
                                {...field}
                                name={[field.name, "pallet_weight"]}
                                fieldKey={[field.fieldKey, "pallet_weight"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input pallet weight!",
                                  },
                                ]}
                              >
                                <InputNumber
                                  placeholder="Pallet Weight"
                                  readOnly={palletType === "besi"}
                                  suffix={"Kg"}
                                  step={"0.1"}
                                  min={0}
                                  style={{ width: "100%" }}
                                  controls={false}
                                />
                              </Form.Item>
                            </Col>
                            {/* Operator */}
                            <Col span={3}>
                              <Form.Item
                                {...field}
                                name={[field.name, "operator_id"]}
                                fieldKey={[field.fieldKey, "operator_id"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input jenis operator!",
                                  },
                                ]}
                              >
                                <SelectOperator />
                              </Form.Item>
                            </Col>

                            {/* Jenis Produk */}
                            <Col span={4}>
                              <Form.Item
                                {...field}
                                name={[field.name, "product_id"]}
                                fieldKey={[field.fieldKey, "product_id"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input jenis produk!",
                                  },
                                ]}
                              >
                                <SelectProduct />
                              </Form.Item>
                            </Col>

                            {/* Spesifikasi */}
                            <Col span={3}>
                              <Form.Item
                                {...field}
                                name={[field.name, "specification"]}
                                fieldKey={[field.fieldKey, "specification"]}
                              >
                                <Input placeholder="Spesifikasi" />
                              </Form.Item>
                            </Col>

                            {/* Berat */}
                            <Col span={2}>
                              <Form.Item
                                {...field}
                                name={[field.name, "weight"]}
                                fieldKey={[field.fieldKey, "weight"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input berat!",
                                  },
                                ]}
                              >
                                <InputNumber
                                  min={0}
                                  placeholder="Berat"
                                  suffix={"Kg"}
                                  step={"0.1"}
                                  controls={false}
                                  style={{
                                    width: "100%",
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            {/*Jumlah Pack */}
                            <Col span={2}>
                              <Form.Item
                                {...field}
                                name={[field.name, "qty"]}
                                fieldKey={[field.fieldKey, "qty"]}
                              >
                                <Input
                                  min={0}
                                  placeholder="Jumlah Pack"
                                  suffix={"Pack"}
                                />
                              </Form.Item>
                            </Col>

                            {/* Area */}
                            <Col span={3}>
                              <Form.Item
                                {...field}
                                name={[field.name, "area"]}
                                fieldKey={[field.fieldKey, "area"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input area!",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Pilih Area"
                                  readOnly
                                  onClick={() => {
                                    showModal();
                                    setSelectionIndex(index);
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            {/* Hapus */}
                            <Col
                              span={1}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Form.Item>
                                <Dropdown
                                  menu={{ items: items(index, remove) }}
                                  trigger={["click"]}
                                >
                                  <EllipsisOutlined />
                                </Dropdown>
                              </Form.Item>
                            </Col>

                            <Col span={1}>
                              <Button
                                type="primary"
                                style={{
                                  backgroundColor: "#4caf50",
                                  color: "#fff",
                                  borderColor: "#4caf50",
                                  width: "100%",
                                }}
                                onClick={() => {
                                  setSelectionIndex(index);
                                  showModalProcess();
                                }}
                              >
                                Process
                              </Button>
                            </Col>
                          </Row>
                        ))}
                        {/* <Button
                          type="dashed"
                          onClick={() => add()}
                          icon={<PlusOutlined />}
                          style={{ width: "100%" }}
                        >
                          Tambah Baris
                        </Button> */}
                      </>
                    )}
                  </Form.List>
                </Form.Item>
              </Col>
              {/* <Col lg={24} md={24} sm={24} xs={24}>
                <Form.Item label="Keterangan" name="note">
                  <TextArea
                    placeholder="Keterangan"
                    autoSize={{
                      minRows: 2,
                      maxRows: 6,
                    }}
                  />
                </Form.Item>
              </Col> */}
              <Col lg={12} md={12} sm={12} xs={24}>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "orange",
                    borderColor: "orange",
                    color: "white",
                  }}
                  type="primary"
                  onClick={() => handleBack()}
                >
                  Kembali
                </Button>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Button
                  onClick={() => {
                    setConfirmInbound(true);
                  }}
                  style={buttonStyle}
                  type="primary"
                  loading={loadingBtn}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
          <Modal
            title="Silahkan Pilih Rak"
            okText="Ok"
            cancelText="Tutup"
            open={open}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            okType={"primary"}
            width="80%"
            height="80%"
            footer={null}
          >
            <SelectLayoutNew
              value={selectedArea?.id}
              onChange={(value) => {
                handleOk(value);

                setSelectedArea(value);
              }}
            />
          </Modal>
          <Modal
            title="Simpan sebagai Draft"
            okText="Ok"
            cancelText="Tutup"
            open={confirmDraft}
            onOk={saveDraft}
            confirmLoading={confirmDraftLoading}
            onCancel={() => setConfirmDraft(false)}
            okType={"primary"}
          >
            <p>Data belum lengkap. Simpan sebagai draft?</p>
          </Modal>

          <Modal
            title="Konfirmasi Inbound"
            okText="Ok"
            cancelText="Tutup"
            open={confirmInbound}
            onOk={() => editForm.submit()}
            confirmLoading={loading}
            onCancel={() => setConfirmInbound(false)}
            okType={"primary"}
          >
            <p>
              Anda akan menyimpan inbound. Apakah data yang diisi sudah sesuai?
            </p>
            <p style={{ color: "red" }}>
              Data yang tersimpan tidak dapat diubah.
            </p>
          </Modal>

          <Process
            openProcess={openProcess}
            setOpenProcess={handleCancelProcess}
            handleOkProcess={handleOkProcess}
            onSelectedPallet={onSelectedPallet}
            selectionIndex={selectionIndex}
          />
        </>
      )}
    </>
  );
};

const buttonStyle = {
  width: "100%",
};

export default StartInbound;
